import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Apple, Smartphone, Wallet, QrCode, ExternalLink } from "lucide-react";

/**
 * Wallet-Pass-Buttons — Apple .pkpass Download + Google Wallet Save-URL.
 * Wird nach erfolgreicher Buchung / auf Ticketseiten angezeigt.
 *
 * Props: ticketId
 */
export default function WalletButtons({ ticketId }) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    if (!ticketId) return;
    api.get(`/tickets/${ticketId}/wallet-info`).then(({ data }) => setInfo(data)).catch(() => {});
  }, [ticketId]);

  if (!info) return null;
  const apple = `${process.env.REACT_APP_BACKEND_URL}${info.apple_pkpass_url}`;

  return (
    <div className="mt-4 space-y-2" data-testid="wallet-buttons">
      <div className="text-[10px] uppercase tracking-[0.32em] text-[#A8A398] flex items-center gap-1.5">
        <Wallet size={11} /> Ticket zu Wallet hinzufügen
      </div>
      <div className="flex gap-2 flex-wrap">
        <a href={apple} download data-testid="wallet-apple-btn"
          className="inline-flex items-center gap-2 bg-black border border-[#F5F0E6]/40 text-[#F5F0E6] px-3 py-2 rounded text-xs hover:border-[#F5F0E6]">
          <Apple size={14} /> Apple Wallet
        </a>
        <a href={info.google_save_url} target="_blank" rel="noreferrer" data-testid="wallet-google-btn"
          className="inline-flex items-center gap-2 bg-black border border-[#4285F4]/60 text-[#8AB4F8] px-3 py-2 rounded text-xs hover:border-[#4285F4]">
          <Smartphone size={14} /> Google Wallet
        </a>
        <a href={info.web_ticket_url} target="_blank" rel="noreferrer" data-testid="wallet-web-btn"
          className="inline-flex items-center gap-2 border border-[#D4AF37]/50 text-[#D4AF37] px-3 py-2 rounded text-xs hover:bg-[#D4AF37]/10">
          <QrCode size={13} /> Web-Ticket (QR)
          <ExternalLink size={11} />
        </a>
      </div>
      {!info.signed && (
        <div className="text-[9px] text-[#575148] italic">
          Apple Wallet: unsigniertes Bundle · für Produktion Apple-Pass-Zertifikat konfigurieren.
        </div>
      )}
    </div>
  );
}
